<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><i>The Age Returns</i>.</p>
<p class="fm2">—Motto of Lorenzo de’ Medici</p>
<p class="fm1"><i>Time itself is a circle, everything recurs</i>.</p>
<p class="fm2">—Friedrich Nietzsche</p>
<p class="fm1"><i>What goes around comes around</i>.</p>
<p class="fm2">—Motto of the Hell’s Angels</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?32853886